import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightPipe } from 'src/modules/shared/pipes/searchHighlight.pipe';
import { SafePipe } from './pipes/safeFilter.pipe';
import { CurrencyValuePipe } from './pipes/currencyValueFilter.pipe';
import { DateValuePipe, DateWitTimeValuePipe, TimeValuePipe } from './pipes/dateValueFilter.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { OrderModule } from 'ngx-order-pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxCurrencyModule } from 'ngx-currency';
import { RobotIconComponent } from './components/robot-icon/robot-icon.component';
import { DynamicFormInputComponent } from './components/dynamic-form-input/dynamic-form-input.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FilesDropZoneComponent } from './components/files-drop-zone/files-drop-zone.component';
import { ThresholdInputComponent } from './components/threshold-input/threshold-input.component';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { CNPJFormatPipe } from './pipes/cnpjFormat.pipe';


@NgModule({
  declarations: [
    HighlightPipe,
    SafePipe,
    CurrencyValuePipe,
    DateValuePipe,
    DateWitTimeValuePipe,
    TimeValuePipe,
    CNPJFormatPipe,
    RobotIconComponent,
    DynamicFormInputComponent,
    FilesDropZoneComponent,
    ThresholdInputComponent,
  ],
  imports: [
    FontAwesomeModule,
    FormsModule,
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    OrderModule,
    CodemirrorModule,
    NgxPaginationModule,
    NgxCurrencyModule,
    NgbModule,
  ],
  exports: [
    HighlightPipe,
    SafePipe,
    CurrencyValuePipe,
    CNPJFormatPipe,
    CodemirrorModule,
    DateValuePipe,
    DateWitTimeValuePipe,
    TimeValuePipe,
    RobotIconComponent,
    DynamicFormInputComponent,
    FilesDropZoneComponent,
    CommonModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    OrderModule,
    NgxPaginationModule,
    NgxCurrencyModule,
    NgbModule,
    ThresholdInputComponent,
  ],
})
export class SharedModule {}
